import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, ZoomControl } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './dashboardElement.css';

// ─── Shared/Dummy Data ────────────────────────────────────────

const STAFF_COLORS = ['#0d9488', '#2563eb', '#7c3aed', '#d97706', '#e11d48'];
const STAFF_ACCENTS = ['accent-teal', 'accent-blue', 'accent-violet', 'accent-amber', 'accent-rose'];

// Admin Dashboard Data
const staffDataAdmin = [
  { id: 1, name: 'Arun Kumar',     visited: 5,  target: 15, color: STAFF_COLORS[0], accent: STAFF_ACCENTS[0], initials: 'AK', lat: 10.0159, lng: 76.3419 },
  { id: 2, name: 'Priya Sharma',   visited: 9,  target: 15, color: STAFF_COLORS[1], accent: STAFF_ACCENTS[1], initials: 'PS', lat: 10.0452, lng: 76.3082 },
  { id: 3, name: 'Rahul Menon',    visited: 12, target: 15, color: STAFF_COLORS[2], accent: STAFF_ACCENTS[2], initials: 'RM', lat: 9.9816,  lng: 76.2999 },
  { id: 4, name: 'Sneha Das',      visited: 7,  target: 15, color: STAFF_COLORS[3], accent: STAFF_ACCENTS[3], initials: 'SD', lat: 10.0261, lng: 76.3125 },
  { id: 5, name: 'Vikas Nair',     visited: 14, target: 15, color: STAFF_COLORS[4], accent: STAFF_ACCENTS[4], initials: 'VN', lat: 9.9936,  lng: 76.2840 },
];

const businessDataAdmin = [
  { staffId: 1, name: 'Arun Kumar',   target: 20000,  initials: 'AK' },
  { staffId: 2, name: 'Priya Sharma', target: 22000,  initials: 'PS' },
  { staffId: 3, name: 'Rahul Menon',  target: 25000,  initials: 'RM' },
  { staffId: 4, name: 'Sneha Das',    target: 20000,  initials: 'SD' },
  { staffId: 5, name: 'Vikas Nair',   target: 250000, initials: 'VN' },
];

const statCardsAdmin = [
  { value: 5,   label: 'Marketing Staffs',     icon: 'fa-users',        accent: 'accent-teal',   trend: '+2',  trendDir: 'up'   },
  { value: 20,  label: 'Core Doctors',          icon: 'fa-user-md',      accent: 'accent-blue',   trend: '+3',  trendDir: 'up'   },
  { value: 35,  label: 'Secondary Doctors',     icon: 'fa-stethoscope',  accent: 'accent-violet', trend: '+8',  trendDir: 'up'   },
  { value: 12,  label: 'Appointments Today',    icon: 'fa-calendar-check', accent: 'accent-amber', trend: '-1', trendDir: 'down' },
  { value: 8,   label: 'Hospitals Covered',     icon: 'fa-hospital',     accent: 'accent-rose',   trend: '+1',  trendDir: 'up'   },
];

// User/Field Staff Dashboard Data (e.g. specifically for Rahul Menon)
const myAssignedDoctors = [
  { id: 1, name: 'Dr. Ramesh Nair',      specialty: 'Cardiologist',    status: 'completed', time: '10:30 AM', clinic: 'Metro Heart Care' },
  { id: 2, name: 'Dr. Anita Joseph',     specialty: 'Pediatrician',    status: 'completed', time: '11:45 AM', clinic: 'Caring Hands Pediatric' },
  { id: 3, name: 'Dr. Sandeep Kurup',    specialty: 'Orthopedic',      status: 'completed', time: '02:15 PM', clinic: 'Elite Bone Clinic' },
  { id: 4, name: 'Dr. Shalini Varma',    specialty: 'Gynaecologist',   status: 'pending',   time: '04:30 PM', clinic: 'Woman & Child Care' },
  { id: 5, name: 'Dr. Thomas George',    specialty: 'General Medicine',status: 'pending',   time: '05:45 PM', clinic: 'City Health Centre' },
];

const doctorTargets = [
  { label: 'Visits Target',   value: '12 / 15', sub: '3 Pending visits' },
  { label: 'Weekly Business', value: '₹25,000', sub: 'Target amount assigned' },
  { label: 'Target Achieved', value: '80%',      sub: 'Excellent progress!' },
  { label: 'Active Session',  value: 'Active',   sub: 'GPS Tracking is Live' },
];

// ─── Helpers ──────────────────────────────────────────────────

const createColoredIcon = (color) =>
  L.divIcon({
    className: '',
    html: `<div class="staff-marker-pulse" style="background:${color}; border-color:${color}; box-shadow: 0 0 0 4px ${color}33;"></div>`,
    iconSize: [18, 18],
    iconAnchor: [9, 9],
  });

const formatCurrency = (v) => '₹' + v.toLocaleString('en-IN');

// ─── Component ────────────────────────────────────────────────

function DashboardElement() {
  const roleId = Number(localStorage.getItem('roleid'));
  const username = localStorage.getItem('username')?.replace(/^./, (c) => c.toUpperCase()) || 'User';

  const todayStr = new Date().toLocaleDateString('en-IN', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const isAdmin = roleId === 1 || roleId === 2;

  // ─────────────────────────────────────────────────────────────
  // RENDER ADMIN DASHBOARD
  // ─────────────────────────────────────────────────────────────
  if (isAdmin) {
    const totalBusiness = businessDataAdmin.reduce((sum, b) => sum + b.target, 0);

    return (
      <div className="dashboard-home">
        {/* Page Header */}
        <div className="dash-page-header">
          <h1 className="dash-greeting">Welcome back, {username} 👋</h1>
          <p className="dash-subtitle">
            <i className="fa fa-calendar-alt" style={{ marginRight: 6, color: '#94a3b8' }}></i>
            {todayStr} &nbsp;·&nbsp; Here's your overview for this week
          </p>
        </div>

        {/* Stat Cards */}
        <div className="stat-cards-row">
          {statCardsAdmin.map((card, i) => (
            <div key={i} className={`stat-card ${card.accent}`}>
              <div className="stat-card-icon">
                <i className={`fa ${card.icon}`}></i>
              </div>
              <div className="stat-card-value">{card.value}</div>
              <div className="stat-card-label">{card.label}</div>
              <div className={`stat-card-trend ${card.trendDir}`}>
                <i className={`fa fa-arrow-${card.trendDir === 'up' ? 'up' : 'down'}`} style={{ fontSize: 10 }}></i>
                {card.trend} this week
              </div>
            </div>
          ))}
        </div>

        {/* Detail Section Header */}
        <div className="section-header">
          <div className="section-header-icon teal">
            <i className="fa fa-chart-bar"></i>
          </div>
          <h2 className="section-title">Weekly Performance Overview</h2>
        </div>

        {/* Detail Cards */}
        <div className="detail-cards-row">
          {/* Weekly Targets */}
          <div className="detail-card">
            <div className="detail-card-header">
              <h3>
                <i className="fa fa-bullseye" style={{ color: '#0d9488' }}></i>
                Weekly Targets of Staffs
              </h3>
              <span className="header-badge">This Week</span>
            </div>
            <div className="detail-card-body">
              {staffDataAdmin.map((staff) => {
                const pct = Math.round((staff.visited / staff.target) * 100);
                return (
                  <div key={staff.id} className="staff-target-item">
                    <div className="staff-avatar" style={{ background: staff.color }}>
                      {staff.initials}
                    </div>
                    <div className="staff-info">
                      <p className="staff-name">Staff {staff.id} — {staff.name}</p>
                      <p className="staff-detail">
                        {staff.visited} of {staff.target} doctors visited
                      </p>
                    </div>
                    <div className="staff-progress-wrap">
                      <span className="staff-progress-label">
                        {staff.visited}/{staff.target}
                      </span>
                      <div className="staff-progress-bar">
                        <div
                          className="staff-progress-fill"
                          style={{
                            width: `${pct}%`,
                            background: `linear-gradient(90deg, ${staff.color}, ${staff.color}cc)`,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Business of this Week */}
          <div className="detail-card">
            <div className="detail-card-header">
              <h3>
                <i className="fa fa-rupee-sign" style={{ color: '#2563eb' }}></i>
                Business of this Week
              </h3>
              <span className="header-badge">Target</span>
            </div>
            <div className="detail-card-body">
              {businessDataAdmin.map((biz, i) => (
                <div key={biz.staffId} className="business-target-item">
                  <div className="business-avatar" style={{ background: STAFF_COLORS[i] }}>
                    {biz.initials}
                  </div>
                  <div className="business-info">
                    <p className="business-name">{biz.name}</p>
                    <p className="business-sub">Staff {biz.staffId} — Weekly Target</p>
                  </div>
                  <div className="business-amount">{formatCurrency(biz.target)}</div>
                </div>
              ))}
              <div className="business-total-row">
                <span className="business-total-label">Total Target</span>
                <span className="business-total-value">{formatCurrency(totalBusiness)}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Map Section Header */}
        <div className="section-header">
          <div className="section-header-icon violet">
            <i className="fa fa-map-marker-alt"></i>
          </div>
          <h2 className="section-title">Live Staff Locations</h2>
        </div>

        {/* Map Card */}
        <div className="map-section">
          <div className="map-card">
            <div className="map-card-header">
              <h3>
                <i className="fa fa-satellite-dish" style={{ color: '#7c3aed' }}></i>
                Real-time Staff Tracking
              </h3>
              <span className="header-badge">{staffDataAdmin.length} Active</span>
            </div>

            {/* Legend */}
            <div className="map-legend">
              {staffDataAdmin.map((s) => (
                <div key={s.id} className="map-legend-item">
                  <div className="map-legend-dot" style={{ background: s.color }}></div>
                  {s.name}
                </div>
              ))}
            </div>

            {/* Map */}
            <div className="map-container-wrap">
              <MapContainer
                center={[10.0159, 76.3119]}
                zoom={13}
                zoomControl={false}
                scrollWheelZoom={true}
                style={{ height: '100%', width: '100%' }}
              >
                <ZoomControl position="topright" />
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {staffDataAdmin.map((staff) => (
                  <Marker
                    key={staff.id}
                    position={[staff.lat, staff.lng]}
                    icon={createColoredIcon(staff.color)}
                  >
                    <Popup>
                      <div style={{ fontFamily: 'Inter, sans-serif', minWidth: 160 }}>
                        <div style={{ fontWeight: 700, fontSize: 14, color: '#1e293b', marginBottom: 4 }}>
                          {staff.name}
                        </div>
                        <div style={{ fontSize: 12, color: '#64748b', marginBottom: 2 }}>
                          Staff {staff.id} · Marketing Executive
                        </div>
                        <div style={{
                          fontSize: 12,
                          color: staff.color,
                          fontWeight: 600,
                          marginTop: 6,
                          padding: '3px 8px',
                          background: `${staff.color}15`,
                          borderRadius: 6,
                          display: 'inline-block'
                        }}>
                          {staff.visited}/{staff.target} doctors visited
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                ))}
              </MapContainer>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="dash-footer">
          <p>
            © {new Date().getFullYear()} DDC Marketing Dashboard · Built for better healthcare outreach
          </p>
        </div>
      </div>
    );
  }

  // ─────────────────────────────────────────────────────────────
  // RENDER USER/FIELD STAFF DASHBOARD (e.g. Rahul Menon)
  // ─────────────────────────────────────────────────────────────
  return (
    <div className="dashboard-home">
      {/* User Welcome Card */}
      <div className="user-welcome-card">
        <div className="user-welcome-text">
          <h2>Welcome back, {username}! 😊</h2>
          <p>
            <i className="fa fa-user-md" style={{ marginRight: 6 }}></i>
            Field Marketing Specialist · Track your active schedule and target details below.
          </p>
          <div className="user-quick-actions">
            <a href="/appointments" className="action-btn">
              <i className="fa fa-calendar-plus"></i> View Appointments
            </a>
            <a href="/doctors" className="action-btn">
              <i className="fa fa-stethoscope"></i> Doctors List
            </a>
          </div>
        </div>
        <div className="user-status-badge">
          <span className="user-status-dot"></span>
          <span>ON DUTY</span>
        </div>
      </div>

      {/* 4 Elegant Boxes/Widgets */}
      <div className="stat-cards-row">
        {/* Box 1: Visited Progress */}
        <div className="stat-card accent-teal">
          <div className="stat-card-icon">
            <i className="fa fa-bullseye"></i>
          </div>
          <div className="stat-card-value">12 / 15</div>
          <div className="stat-card-label">Doctors Visited</div>
          <div className="stat-card-trend up">
            <i className="fa fa-check" style={{ fontSize: 10 }}></i>
            80% Achieved
          </div>
        </div>

        {/* Box 2: Target Business */}
        <div className="stat-card accent-blue">
          <div className="stat-card-icon">
            <i className="fa fa-rupee-sign"></i>
          </div>
          <div className="stat-card-value">₹25,000</div>
          <div className="stat-card-label">Weekly Business Target</div>
          <div className="stat-card-trend up">
            <i className="fa fa-arrow-up" style={{ fontSize: 10 }}></i>
            Active Week
          </div>
        </div>

        {/* Box 3: Pending Visits */}
        <div className="stat-card accent-violet">
          <div className="stat-card-icon">
            <i className="fa fa-clock"></i>
          </div>
          <div className="stat-card-value">3</div>
          <div className="stat-card-label">Pending Visits Today</div>
          <div className="stat-card-trend down">
            <i className="fa fa-exclamation" style={{ fontSize: 10 }}></i>
            Due today
          </div>
        </div>

        {/* Box 4: GPS Tracking Status */}
        <div className="stat-card accent-rose">
          <div className="stat-card-icon">
            <i className="fa fa-map-marker-alt"></i>
          </div>
          <div className="stat-card-value">Active</div>
          <div className="stat-card-label">Tracking Mode</div>
          <div className="stat-card-trend up">
            <i className="fa fa-satellite-dish" style={{ fontSize: 10 }}></i>
            GPS Connected
          </div>
        </div>
      </div>

      {/* Detail Section */}
      <div className="detail-cards-row">
        {/* Left Side: Assigned Doctor Visits for Today */}
        <div className="detail-card">
          <div className="detail-card-header">
            <h3>
              <i className="fa fa-list-check" style={{ color: '#0d9488' }}></i>
              My Target Visits for Today
            </h3>
            <span className="header-badge">Today</span>
          </div>
          <div className="detail-card-body">
            <div className="doctor-task-list">
              {myAssignedDoctors.map((doc) => (
                <div key={doc.id} className={`doctor-task-item ${doc.status}`}>
                  <div className="doctor-task-details">
                    <div className="doctor-task-avatar">
                      {doc.name.split(' ')[1][0] + (doc.name.split(' ')[2] ? doc.name.split(' ')[2][0] : '')}
                    </div>
                    <div className="doctor-task-info">
                      <h4>{doc.name}</h4>
                      <p>{doc.specialty} · {doc.clinic}</p>
                    </div>
                  </div>
                  <span className={`doctor-task-status-badge ${doc.status}`}>
                    {doc.status === 'completed' ? (
                      <><i className="fa fa-check" style={{ marginRight: 4 }}></i> Visited</>
                    ) : (
                      <><i className="fa fa-clock" style={{ marginRight: 4 }}></i> {doc.time}</>
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Side: Map showing current user's target neighborhood */}
        <div className="detail-card">
          <div className="detail-card-header">
            <h3>
              <i className="fa fa-map-location-dot" style={{ color: '#2563eb' }}></i>
              My Target Area Map
            </h3>
            <span className="header-badge">Kochi South</span>
          </div>
          <div className="map-container-wrap" style={{ height: '310px' }}>
            <MapContainer
              center={[9.9816, 76.2999]}
              zoom={14}
              zoomControl={false}
              scrollWheelZoom={true}
              style={{ height: '100%', width: '100%' }}
            >
              <ZoomControl position="topright" />
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {/* User location (Pulsing Purple Marker) */}
              <Marker
                position={[9.9816, 76.2999]}
                icon={createColoredIcon('#7c3aed')}
              >
                <Popup>
                  <div style={{ fontFamily: 'Inter, sans-serif' }}>
                    <div style={{ fontWeight: 700, color: '#1e293b' }}>My Current Location</div>
                    <div style={{ fontSize: 11, color: '#64748b' }}>Active GPS Tracking is turned on.</div>
                  </div>
                </Popup>
              </Marker>

              {/* Doctors/Clinics location pins in the area */}
              <Marker position={[9.9840, 76.3050]}>
                <Popup><strong>Woman & Child Care</strong><br />Dr. Shalini Varma (Gynaecologist)</Popup>
              </Marker>
              <Marker position={[9.9780, 76.2950]}>
                <Popup><strong>City Health Centre</strong><br />Dr. Thomas George (General Medicine)</Popup>
              </Marker>
            </MapContainer>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="dash-footer">
        <p>
          © {new Date().getFullYear()} DDC Marketing Dashboard · Built for better healthcare outreach
        </p>
      </div>
    </div>
  );
}

export default DashboardElement;